import { memo } from 'react';
import styled, { css } from 'styled-components';

type Props = {
  html: string;
  renderInline?: boolean;
};

const baseStyles = css`
  p {
    margin: 0;
  }
`;

const StyledSpan = styled.span`
  ${baseStyles}
`;

const StyledDiv = styled.div`
  ${baseStyles}
`;
export const MemoizedDangerouslyRenderedHtml = memo(({ html, renderInline = false }: Props) => {
  if (renderInline) {
    return <StyledSpan dangerouslySetInnerHTML={{ __html: html }} />;
  }

  return <StyledDiv dangerouslySetInnerHTML={{ __html: html }} />;
});
